var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGCalendar = function SvgGCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1967D2",
    d: "M18.825 0h-3.252v4.711h4.758V1.328c.001 0-.235-1.2-1.506-1.328m-3.25 19.979V20l4.758-4.71h-.043z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M20.332 15.288v-.042l-.042.042zm.001-10.578h-4.758v10.536h4.758V4.711Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M20.29 15.29h-4.715v4.689l4.715-4.69Zm-4.715-.002h4.715l.043-.042h-4.758z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M15.563 19.99h.012v-.012l-.011.011ZM4.982 15.246v4.743h10.581l.012-4.743z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M15.575 15.289v-.043l-.011 4.743.011-.011z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#188038",
    d: "M.333 15.246v3.298c.043 1.07 1.2 1.445 1.2 1.445h3.45v-4.743z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M4.983 4.711h10.593V0H1.667S.418.128.333 1.456v13.79h4.65z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M8.448 13.114q-.364 0-.701-.095a2.1 2.1 0 0 1-.606-.284 2.2 2.2 0 0 1-.494-.49 2.3 2.3 0 0 1-.32-.68l1.065-.423q.113.43.38.655.269.215.676.215.18 0 .346-.052a.9.9 0 0 0 .285-.164.8.8 0 0 0 .19-.24.7.7 0 0 0 .079-.328.7.7 0 0 0-.286-.594q-.277-.215-.77-.215h-.51V9.395h.466q.174 0 .338-.043a.9.9 0 0 0 .286-.13.64.64 0 0 0 .199-.232.7.7 0 0 0 .078-.335.6.6 0 0 0-.208-.474q-.208-.19-.563-.19-.381 0-.588.207a1.1 1.1 0 0 0-.277.448l-1.039-.422q.078-.215.234-.439a1.8 1.8 0 0 1 .39-.413 2 2 0 0 1 .562-.301q.32-.12.736-.12.424 0 .77.12.354.12.606.335a1.43 1.43 0 0 1 .528 1.12q0 .258-.07.464-.06.207-.164.37a1.3 1.3 0 0 1-.51.465v.07q.414.162.683.524.277.361.277.913 0 .387-.147.714a1.7 1.7 0 0 1-.424.56q-.269.24-.65.37a2.5 2.5 0 0 1-.847.137Zm4.135-.138V8.414l-1.047.439-.416-.956 1.74-.81h.857v5.889z"
  })));
};
export default SvgGCalendar;